import { render } from "./Name.vue?vue&type=template&id=656e7e74&scoped=true&ts=true"
import script from "./Name.vue?vue&type=script&lang=ts"
export * from "./Name.vue?vue&type=script&lang=ts"

import "./Name.vue?vue&type=style&index=0&id=656e7e74&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656e7e74"]])

export default __exports__